import React from "react";

import AddIcon from "@mui/icons-material/Add";
import { AddInfoButtonDiv, AddInfoButtonTextDiv } from "./styled";

export const AddInfoButton = ({ text, handleAddClick }) => {
  return (
    <AddInfoButtonDiv onClick={handleAddClick}>
      <AddIcon fontSize="large" sx={{ color: "#104467" }} />
      <AddInfoButtonTextDiv>{text}</AddInfoButtonTextDiv>
    </AddInfoButtonDiv>
  );
};
